import type { KYCQuestionDefinition } from '@anchorage/graphql/generated';
import type { CustomLinkProps } from '@anchorage/utils';
import { parseSanitize } from '@anchorage/utils';
import { FormInput, reactHookForm } from '@latitude/form';
import type { ComponentType } from 'react';

import css from './styles.module.css';

type Props = {
  question: KYCQuestionDefinition;
  isDisabled?: boolean;
  trackFn?: (questionId: string) => void;
  CustomLink?: ComponentType<CustomLinkProps>;
};

function TextFieldComponent({
  question,
  isDisabled = false,
  trackFn = () => {},
  CustomLink,
}: Props) {
  const { control } = reactHookForm.useFormContext();

  return (
    <FormInput
      wrapperClassname={css.textFieldWrapper}
      message={parseSanitize(question?.footer, CustomLink) || ''}
      control={control}
      name={`${question.id}.freeformText`}
      readOnly={isDisabled}
      rawProps={{ maxLength: 512, onChangeCapture: () => trackFn(question.id) }}
      inputSize="medium"
      onClear={() => trackFn?.(question.id)}
      data-testid={`input-${question.id}`}
    />
  );
}

export { TextFieldComponent };
